export const SOL_MIGRATION_CHANGE_VALUE = 'SOL_MIGRATION_CHANGE_VALUE';
